import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Icon from 'components/Icon';
import { StyledSelect } from 'lib/styles';

import {
	Container,
	TagRemove,
	TagContainer,
	ListTypeContainer,
	Note
} from './styles';

const Tag = props => {
	const name = props.type === 'text' ? '"' + props.name + '"' : props.name;

	return (
		<TagContainer {...props}>
			{name}
			<TagRemove>&times;</TagRemove>
		</TagContainer>
	);
}

Tag.propTypes = {
	type: PropTypes.string,
	name: PropTypes.string,
}

const ListType = props => {
	const types = ['tile', 'list'].map(type => {
		const active = type === props.active;
		const iconClass = 'list-type-toggle' + ( active ? ' active' : '' );
		const icon = 'view-' + type

		return (
			<Icon
				key={type}
				tag="button"
				icon={icon}
				iconclass={iconClass}
				onClick={() => props.changeBrowseTypeHandler(type)}
			/>);
	});

	return (
		<ListTypeContainer>
			{types}
		</ListTypeContainer>
	);
}

ListType.propTypes = {
	active: PropTypes.oneOf(['tile', 'list']),
}


const SortAndFilters = props => {
	const { t } = props;
	let tags = <Note>{props.buildingCount === 0 ? t('browse/Loading buildings') : t('browse/Listing all buildings')}</Note>;

	if (props.activeFilters.length > 0) {
		tags = props.activeFilters.map((filter, filterIndex) => {
			return (
				<Tag
					key={filter.type + filter.value + filterIndex}
					{...filter}
					onClick={() => { props.removeFilterTag(filterIndex)}}
				/>
			);
		});

		tags.push(<Note key="note">{t('browse/Building count', { count: props.buildingCount})}</Note>);
	}

	const sortOptions = [
		{ value: 'abc', name: t('app/sort/abc') },
		{ value: 'abc_name', name: t('app/sort/abc_building_name') },
		{ value: 'size', name: t('app/sort/area') },
	];

	return (
		<Container>
			<div>
				<StyledSelect
					id="sort"
					defaultValue={props.sort}
					options={sortOptions}
					style={{ backgroundColor: 'rgba(0,0,0,0)', padding: 0, height: '24px' }}
					onChange={props.browseSortChangeHandler}
				/>

				{ tags }

				<Note htmlFor="only-show-free" style={{ opacity: props.browse.onlyShowBuildingsWithFreeSpaces ? 1 : 0.5 }}>
					<input
						id="only-show-free"
						type="checkbox"
						checked={props.browse.onlyShowBuildingsWithFreeSpaces}
						onChange={props.toggleOnlyShowFreeHandler}
					/>
					{t(props.activeFilters.length > 0 ? 'browse/Only show free spaces' : 'browse/Only show buildings with free spaces')}
				</Note>
			</div>
			<ListType active={props.browseType} changeBrowseTypeHandler={props.changeBrowseTypeHandler} />
		</Container>
	);
};

SortAndFilters.propTypes = {
	t: PropTypes.func,
	buildingCount: PropTypes.number,
	browse: PropTypes.object,
	activeFilters: PropTypes.array,
	sort: PropTypes.oneOf(['abc', 'abc_name', 'size']),
	browseType: PropTypes.oneOf(['tile', 'list']),
	toggleOnlyShowFreeHandler: PropTypes.func,
	changeBrowseTypeHandler: PropTypes.func,
	browseSortChangeHandler: PropTypes.func,
}

export default translate('translations')(SortAndFilters)
